import cssTokens from './WixStyleReactProvider/newBrandingTokens';

export const COLOR_TOKENS = cssTokens();
